export const Types = {
  CHANGE_MENU: "menu/CHANGE_MENU"
};

const INITIAL_STATE = {
  disposicao: localStorage.getItem("@ecorban-app:menu")
    ? localStorage.getItem("@ecorban-app:menu")
    : "vertical"
};

export default function menu(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.CHANGE_MENU:
      return {
        ...state,
        disposicao: action.payload.disposicao
      };
    default:
      return state;
  }
}

export const Creators = {
  changeMenu: disposicao => ({
    type: Types.CHANGE_MENU,
    payload: { disposicao }
  })
};



// WEBPACK FOOTER //
// ./src/store/ducks/menu.js